import React, { useState, useRef, useEffect, useIP } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Home from "../../assets/images/casino-icons/home2.svg";

import {
  sideBarList,
  Languages,
  getCookies,
  getReadableDate,
  cmsSideBarList,
  casinoIcons,
} from "../../helper/utils";

import { useTheme } from "../../routes/private-route";

import { getDreamCasinoGames } from "../../redux/slices/games/casino/dreamCasinoGameListSlice";
import { editProfile } from "../../redux/slices/profile/updateProfileSlice";
import { config } from "../../redux/slices/auth/configSlice";

import { getProfile } from "../../redux/slices/profile/fetchProfileSlice";
import { getAllNotification } from "../../redux/slices/notification/getAllNotificationSlice";
import { markSeen } from "../../redux/slices/notification/markSeenSlice";
import { markSeenAll } from "../../redux/slices/notification/markSeenAllSlice";
import UserProfile from "../../assets/images/UserProfile.png";
import Left from "../../assets/images/svgs/left.svg";
import Logo from "../../assets/images/logo-small.png";
import Ball from "../../assets/images/svgs/ball.svg";
import Profile from "../../assets/images/svgs/signup.png";
import login from "../../assets/images/svgs/login.svg";
import Notification from "../../assets/images/svgs/notification.svg";
import Logout from "../../assets/images/svgs/logout.png";
import Search from "../../assets/images/svgs/search.svg";
import casinoMain from "../../assets/images/svgs/casinoMain.svg";
import { LogoutModal } from "../../components";

const Navbar = () => {
  const { theme, toggleTheme, setGameSearch } = useTheme();
  const auth = getCookies("xcasino_token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const bypassAnnouncement = ["/game-section"];
  const [query, setQuery] = useState("");
  const { t, i18n } = useTranslation();

  const {
    loading,
    error: profileError,
    data: profileData,
  } = useSelector((state) => state.getProfile);

  console.log("profileData", profileData);

  const configData = useSelector((state) => state.config.data);

  const [currentPage, setCurrentPage] = useState("");

  const [hoverProfile, setHoverProfile] = useState(false);
  const [hoverTheme, setHoverTheme] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [logoutModal, setLogoutModal] = useState(false);
  // const [open, setOpen] = useState(menuOpen);
  const [notificationToggle, setNotificationToggle] = useState(false);
  const { innerWidth: width, innerHeight: height } = window;
  const [lang, setLang] = useState("en");

  const [showHeader, setShowHeader] = useState(false);

  useEffect(() => {
    if (!configData?.headerSettings) return;

    let hasMessage = false;
    let showValue = null;

    configData.headerSettings.forEach((setting) => {
      if (setting.api_key === "header_announcement") {
        hasMessage = true;
      }
      if (setting.api_key === "show_header_announcement") {
        showValue = setting.value.toLowerCase() === "true";
      }
    });

    if (hasMessage && showValue !== null) {
      setShowHeader(showValue);
    } else {
      setShowHeader(false);
    }
  }, [configData]);

  useEffect(() => {
    window.addEventListener("unload", handleSignout);
    return () => {
      window.removeEventListener("unload", handleSignout);
    };
  }, []);

  useEffect(() => {
    if (query === "") return;

    const timer = setTimeout(() => {
      // getData();

      setGameSearch(query);
    }, 3000);

    return () => clearTimeout(timer);
  }, [query]);

  const handleSettings = (field, lng) => {
    let payload;
    // if (field == "color_mode") {
    //   payload = {
    //     id: profileData.user._id,
    //     color_mode: theme == "Dark" ? "Light" : "Dark",
    //   };
    // }
    if (field == "notification") {
      payload = {
        id: profileData.user._id,
        notification: !notificationToggle,
      };
    } else if (field == "language") {
      payload = {
        id: profileData.user._id,
        language: lng,
      };
    }

    dispatch(editProfile(payload))
      .unwrap()
      .then((res) => {
        handleConfig(res.user.parent_user_id, res.user._id);
        getProfileData();
      })
      .catch((error) => {
        console.error("Failed :", error);
      });
  };

  useEffect(() => {
    if (!profileData) {
      getProfileData();
    } else {
      toggleTheme(
        profileData?.user?.color_mode ? profileData?.user?.color_mode : "Dark"
      );
      setNotificationToggle(profileData?.user?.notification);
      setLang(profileData?.user?.language);
      i18n.changeLanguage(profileData?.user?.language);
    }
  }, [profileData, auth]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLang(lng);

    handleSettings("language", lng);
  };

  const handleSidebarClick = (e) => {
    navigate(`/${e.url}`);
    setCurrentPage(e.label);
  };

  const handleSignout = () => {
    setLogoutModal(true);
  };

  const getProfileData = () => {
    if (auth) {
      dispatch(getProfile())
        .unwrap()
        .then((res) => {
          handleConfig(res.user.parent_user_id, res.user._id);
        })
        .catch((error) => {
          console.error("Failed :", error);
        });
    }
  };

  const handleConfig = (id, userId) => {
    const domain = process.env.REACT_APP_FRONT_URL;
    const vpnToken = localStorage.getItem("vpnToken");
    const payload = {  parentId: id, userId: userId, vpnToken };

    dispatch(config(payload))
      .unwrap()
      .then((res) => {})
      .catch((error) => {
        console.error("Failed :", error);
      });
  };

  useEffect(() => {
    if (auth && profileData?.user?.notification) {
      handleGetAllNotification();
    }
  }, [auth, profileData]);

  const handleGetAllNotification = () => {
    dispatch(getAllNotification())
      .unwrap()
      .then((res) => {
        setNotifications(res.notifications);
      })
      .catch((error) => {
        console.error("Failed :", error);
      });
  };

  const handleMarkSeen = (all, id) => {
    if (all) {
      dispatch(markSeenAll())
        .unwrap()
        .then((res) => {})
        .catch((error) => {
          console.error("Failed :", error);
        });
    } else {
      dispatch(markSeen({ _id: id }))
        .unwrap()
        .then((res) => {})
        .catch((error) => {
          console.error("Failed :", error);
        });
    }
  };

  function openNotification() {
    navigate("/notification");
    // document.getElementById("notificationPanel").classList.add("active");
  }

  function closeNotification() {
    // document.getElementById("notificationPanel").classList.remove("active");
  }

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".app-navbar-item")) {
        setHoverProfile(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getProfileData();
      // profileData();
    }, 1 * 60 * 1000); // 2 minutes in milliseconds

    return () => clearInterval(interval); // cleanup on unmount
  }, [auth]);

  return (
    <>
      <div id="navbar-wrapper">
        <nav
          className="navbar navbar-inverse d-block"
          style={{
            top:
              showHeader && !bypassAnnouncement.includes(location.pathname)
                ? 25
                : 0,
          }}
        >
          <LogoutModal open={logoutModal} setOpen={setLogoutModal} />
          {window.innerWidth < 768 ? (
            <div className="d-flex flex-column px-3 pt-2 gap-3">
              {/* Profile + Theme Switch */}

              <div className="d-flex justify-content-between align-items-center">
                <img
                  src={
                    configData?.website_logo ? configData?.website_logo : Logo
                  }
                  alt=""
                  className="cursor-pointer footer-logo"
                  onClick={() => {
                    navigate("/");
                  }}
                  style={{ maxHeight: "50px", width: "auto" }}
                />
                <div className="d-flex cursor-pointer align-items-center gap-2">
                   <div
                                    onClick={() => {
                                      navigate("/");
                                    }}
                                  >
                                    <img
                                      src={Home}
                                      alt="icon"
                                      width={22}
                                      height={22}
                                      className={`svg-icon home-icon me-1 ms-1 `}
                                    />
                                  </div>
                  {/* Theme Toggle */}
                  {!location?.pathname.substring("game-section") && (
                    <label className="theme-toggle mb-0">
                      <input
                        type="checkbox"
                        checked={theme === "Light"}
                        disabled={!profileData}
                        onChange={() => {
                          handleSettings("color_mode");
                          toggleTheme(theme === "Dark" ? "Light" : "Dark");
                        }}
                      />
                      <span className="slider">
                        <span className="icon sun">☀️</span>
                        <span className="icon moon">🌙</span>
                      </span>
                    </label>
                  )}

                  {profileData?.user?.notification && (
                    <div
                      className="app-navbar-item ms-1 ms-md-3 align-self-center"
                      onClick={() => {
                        openNotification();
                      }}
                    >
                      <img
                        src={Notification}
                        width={30}
                        height={30}
                        className="svg-icon svg-icon-2 text-center"
                      />
                    </div>
                  )}

                  <div className="notification-panel" id="notificationPanel">
                    <div className="notification-header">
                      <h2 className="fw-bold hero-heading">Notifications</h2>
                      <button
                        className="close-btn"
                        onClick={() => {
                          closeNotification();
                        }}
                      >
                        ×
                      </button>
                    </div>
                    <div className="notification-content">
                      {notifications.map((itm, index) => (
                        <div key={index} className="notification-item ">
                          <span className="fs-16 text-white">
                            <span className="fw-semibold">{itm.title}</span>
                            <br />
                            <span className="">{itm.description}</span>
                          </span>
                          <div className="d-flex justify-content-between">
                            <span className="w-100 fs-12 text-white opacity-50">
                              {getReadableDate(itm.createdAt)}
                            </span>
                            <span
                              className="w-100 fs-12 text-purple cursor-pointer text-end"
                              onClick={() => {
                                handleMarkSeen(false, itm.userNotificationId);
                              }}
                            >
                              Mark as read
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {profileData ? (
                    <div className="app-navbar-item ms-md-3 align-self-center">
                      <div
                        className="cursor-pointer symbol symbol-30px symbol-md-40px"
                        // onMouseOver={() => {
                        //   setHoverProfile(true);
                        //   setHoverTheme(false);
                        // }}
                        onClick={() => {
                          setHoverProfile((prev) => !prev); // toggle on click
                          setHoverTheme(false);
                        }}
                      >
                        <span
                          className="svg-icon svg-icon-2 text-capitalize"
                          style={{
                            borderRadius: "50%",
                            width: "50px",
                            height: "40px",
                            padding: "7px 15px",
                            color: "white",
                            background: "var(--secondary-accent)",
                          }}
                        >
                          {profileData?.user?.name?.charAt(0)}
                        </span>
                        {/* <img
                        src={profileData?.user?.profile_pic || UserProfile}
                        className="svg-icon svg-icon-2"
                      /> */}
                      </div>

                      {hoverProfile && (
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-gray-800 py-3 pb-2 mt-3 fs-6"
                          // onMouseOver={() => {
                          //   setHoverProfile(true);
                          // }}
                          // onMouseOut={() => {
                          //   setHoverProfile(false);
                          // }}
                          // onClick={(e) => {
                          //   e.nativeEvent.stopImmediatePropagation();
                          // }}
                          onClick={(e) => {
                            e.nativeEvent.stopImmediatePropagation();
                          }}
                          style={{ zIndex: 999 }}
                        >
                          <div className="menu-item px-3 cursor-none">
                            <div className="menu-content d-flex align-items-center ">
                              <div className="d-flex align-items-center mb-3 gap-2">
                                <div className="symbol symbol-50px me-1">
                                  <img
                                    src={
                                      profileData?.user?.profile_pic ||
                                      UserProfile
                                    }
                                    alt="User"
                                    className="rounded-circle object-fit-cover"
                                  />
                                </div>
                                <div className="menu-section">
                                  <div className="fw-bold">
                                    {profileData?.user?.username}
                                  </div>
                                  <div className="fs-12">
                                    {profileData?.user?.mobile}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {sideBarList.map((item, idx) => (
                            <div key={idx}>
                              <div className="separator my-1"></div>

                              <div
                                className={`menu-item px-2 py-1 mx-2 ${
                                  item.label === currentPage
                                    ? "active side-link"
                                    : ""
                                }`}
                                onClick={() => {
                                  handleSidebarClick(item);
                                }}
                              >
                                <span className="svg-icon svg-icon-2  ">
                                  {item.img}
                                </span>
                                <span className="menu-link fs-14 px-2">
                                  {item.label}
                                </span>
                              </div>
                            </div>
                          ))}

                          <div className="separator my-1"></div>

                          <div
                            className="menu-item-logout px-2 py-1 mx-2"
                            onClick={() => {
                              console.log("signout");
                              handleSignout();
                            }}
                          >
                            <span className="svg-icon svg-icon-2  ">
                              <img
                                src={Logout}
                                alt="icon"
                                width={22}
                                height={22}
                                className="svg-icon"
                              />
                            </span>
                            <span className="menu-link fs-14 px-2">Logout</span>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                        <span
                          className="box-purple text-white-btn fs-14 py-2 px-2 align-self-center cursor-pointer"
                          onClick={() => {
                            navigate("/signin-username");
                          }}
                        >
                          <img src={login} alt="icon" className="svg-icon" />{" "}
                          {t("SignUpPage.login")}
                        </span>
                      </div>
                      <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                        <span
                          className="box-purple text-white-btn  fs-14 py-2 px-2 align-self-center cursor-pointer"
                          onClick={() => {
                            navigate("/signup");
                          }}
                        >
                          <img src={Profile} alt="icon" className="svg-icon" />{" "}
                          {t("SignUpPage.signUp")}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Language + Balance */}
              {!location?.pathname.substring("game-section") && (
                <div className="d-flex justify-content-between align-items-center">
                  <div className="app-navbar-item ms-1 ms-md-3 align-self-center  ">
                    <select
                      name={"language"}
                      value={lang}
                      aria-label={`Language`}
                      data-control="select2"
                      data-placeholder={`Select`}
                      className="form-select select-lng p-1 ps-2 cursor-pointer"
                      onChange={(e) => {
                        changeLanguage(e.target.value);
                      }}
                    >
                      {Languages?.map((item, index) => (
                        <option
                          key={index}
                          value={item.value}
                          onClick={(e) => {}}
                        >
                          <b>{item.label}</b>
                        </option>
                      ))}
                    </select>
                  </div>

                  {profileData?.user && (
                    <div className="d-flex d-sm-flex d-md-flex d-lg-block d-xl-block  app-navbar-item ms-1 py-1 px-2 border-grey rounded-4 text-white fw-semibold fs-14 ms-md-3 align-self-center">
                      <span className="fs-10 align-self-center me-1 d-block">
                        {t("Sidebar.balance")}:{" "}
                        {/* {profileData?.user?.usable_coin_balance?.toFixed(2)} */}
                        {(Number(profileData?.user?.usable_coin_balance) - Number(profileData?.user?.current_liability)).toFixed(2)}
                      </span>
                      {/* <br /> */}
                      {/* <span className="fs-10 align-self-center d-block me-1">
                        Exposure: {profileData?.user?.current_liability}
                      </span> */}
                      {/* <br /> */}
                      <span className="fs-10 align-self-center d-block me-1">
                        {t("Sidebar.bonus")}:{" "}
                        {profileData?.user?.bonus_wallet?.toFixed(2)}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <div
              className=" d-flex flex-wrap justify-content-between "
              //   style={{
              //     width: `${
              //       menuOpen ? window.innerWidth - 270 : window.innerWidth - 80
              //     }px`,
              //   }}
            >
              <div className="d-flex ms-3">
                <img
                  src={
                    configData?.website_logo ? configData?.website_logo : Logo
                  }
                  alt=""
                  className="cursor-pointer footer-logo"
                  onClick={() => {
                    navigate("/");
                  }}
                  style={{ maxHeight: "50px", width: "auto" }}
                />
              </div>

              <div className="app-navbar d-flex cursor-pointer flex-shrink-0 me-3 ">
                <div className="d-flex mt-2 mt-xs-2 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
                  <div className="theme-switch-wrapper d-flex align-items-center gap-2">
                    {/* <span
                      className={`theme-label ${
                        theme === "Dark" ? "active" : ""
                      }`}
                    >
                      🌙 {t("Common.dark")}
                    </span> */}
                    {!location?.pathname.substring("game-section") && (
                      <label className="theme-toggle">
                        <input
                          type="checkbox"
                          checked={theme === "Light"}
                          disabled={!profileData}
                          onChange={() => {
                            handleSettings("color_mode");
                            toggleTheme(theme === "Dark" ? "Light" : "Dark");
                          }}
                        />
                        <span className="slider">
                          <span className="icon sun">☀️</span>
                          <span className="icon moon">🌙</span>
                        </span>
                      </label>
                    )}

                    {/* <span
                      className={`theme-label ${
                        theme === "Light" ? "active" : ""
                      }`}
                    >
                      ☀️ {t("Common.light")}
                    </span> */}
                  </div>

                  {!location?.pathname.substring("game-section") && (
                    <div className="app-navbar-item ms-1 ms-md-3 align-self-center  ">
                      <select
                        name={"language"}
                        value={lang}
                        aria-label={`Language`}
                        data-control="select2"
                        data-placeholder={`Select`}
                        className="form-select select-lng p-1 ps-2 cursor-pointer"
                        onChange={(e) => {
                          changeLanguage(e.target.value);
                        }}
                      >
                        {Languages?.map((item, index) => (
                          <option
                            key={index}
                            value={item.value}
                            onClick={(e) => {}}
                          >
                            <b>{item.label}</b>
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {!location?.pathname.substring("game-section") &&
                    profileData?.user && (
                      <div className="d-flex d-sm-flex d-md-flex d-lg-block d-xl-block  app-navbar-item ms-1 py-1 px-2 border-grey rounded-4 text-white fw-semibold fs-14 ms-md-3 align-self-center">
                        <span className="fs-10 align-self-center me-1 d-block">
                          {t("Sidebar.balance")}:{" "}
                          {/* {profileData?.user?.usable_coin_balance?.toFixed(2)} */}
                          {(Number(profileData?.user?.usable_coin_balance) - Number(profileData?.user?.current_liability)).toFixed(2)}
                        </span>
                        {/* <br /> */}
                        {/* <span className="fs-10 align-self-center d-block me-1">
                          Exposure: {profileData?.user?.current_liability}
                        </span> */}
                        {/* <br /> */}
                        <span className="fs-10 align-self-center d-block me-1">
                          {t("Sidebar.bonus")}:{" "}
                          {profileData?.user?.bonus_wallet?.toFixed(2)}
                        </span>
                      </div>
                    )}

                  {profileData?.user?.notification && (
                    <div
                      className="app-navbar-item ms-1 ms-md-3 align-self-center"
                      onClick={() => {
                        openNotification();
                      }}
                    >
                      <img
                        src={Notification}
                        width={30}
                        height={30}
                        className="svg-icon svg-icon-2 text-center"
                      />
                    </div>
                  )}
                </div>

                <div className="notification-panel" id="notificationPanel">
                  <div className="notification-header">
                    <h2 className="fw-bold hero-heading">Notifications</h2>
                    <button
                      className="close-btn"
                      onClick={() => {
                        closeNotification();
                      }}
                    >
                      ×
                    </button>
                  </div>
                  <div className="notification-content">
                    {notifications.map((itm, index) => (
                      <div key={index} className="notification-item ">
                        <span className="fs-16 text-white">
                          <span className="fw-semibold">{itm.title}</span>
                          <br />
                          <span className="">{itm.description}</span>
                        </span>
                        <div className="d-flex justify-content-between">
                          <span className="w-100 fs-12 text-white opacity-50">
                            {getReadableDate(itm.createdAt)}
                          </span>
                          <span
                            className="w-100 fs-12 text-purple cursor-pointer text-end"
                            onClick={() => {
                              handleMarkSeen(false, itm.userNotificationId);
                            }}
                          >
                            Mark as read
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {profileData ? (
                  <div className="app-navbar-item ms-md-3 align-self-center">
                    <div
                      className="cursor-pointer symbol symbol-30px symbol-md-40px"
                      // onMouseOver={() => {
                      //   setHoverProfile(true);
                      //   setHoverTheme(false);
                      // }}
                      onClick={() => {
                        setHoverProfile((prev) => !prev); // toggle on click
                        setHoverTheme(false);
                      }}
                    >
                      <span
                        className="svg-icon svg-icon-2 text-capitalize"
                        style={{
                          borderRadius: "50%",
                          width: "50px",
                          height: "40px",
                          padding: "7px 15px",
                          color: "white",
                          background: "var(--secondary-accent)",
                        }}
                      >
                        {profileData?.user?.name?.charAt(0)}
                      </span>
                      {/* <img
                        src={profileData?.user?.profile_pic || UserProfile}
                        className="svg-icon svg-icon-2"
                      /> */}
                    </div>

                    {hoverProfile && (
                      <div
                        className="menu menu-sub menu-sub-dropdown menu-gray-800 py-3 pb-2 mt-3 fs-6"
                        // onMouseOver={() => {
                        //   setHoverProfile(true);
                        // }}
                        // onMouseOut={() => {
                        //   setHoverProfile(false);
                        // }}
                        // onClick={(e) => {
                        //   e.nativeEvent.stopImmediatePropagation();
                        // }}
                        onClick={(e) => {
                          e.nativeEvent.stopImmediatePropagation();
                        }}
                        style={{ zIndex: 999 }}
                      >
                        <div className="menu-item px-3 cursor-none">
                          <div className="menu-content d-flex align-items-center ">
                            <div className="d-flex align-items-center mb-3 gap-2">
                              <div className="symbol symbol-50px me-1">
                                <img
                                  src={
                                    profileData?.user?.profile_pic ||
                                    UserProfile
                                  }
                                  alt="User"
                                  className="rounded-circle object-fit-cover"
                                />
                              </div>
                              <div className="menu-section">
                                <div className="fw-bold">
                                  {profileData?.user?.username}
                                </div>
                                <div className="fs-12">
                                  {profileData?.user?.mobile}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {sideBarList.map((item, idx) => (
                          <div key={idx}>
                            <div className="separator my-1"></div>

                            <div
                              className={`menu-item px-2 py-1 mx-2 ${
                                item.label === currentPage
                                  ? "active side-link"
                                  : ""
                              }`}
                              onClick={() => {
                                handleSidebarClick(item);
                              }}
                            >
                              <span className="svg-icon svg-icon-2  ">
                                {item.img}
                              </span>
                              <span className="menu-link fs-14 px-2">
                                {item.label}
                              </span>
                            </div>
                          </div>
                        ))}

                        <div className="separator my-1"></div>

                        <div
                          className="menu-item-logout px-2 py-1 mx-2"
                          onClick={() => {
                            console.log("signout 820");
                            handleSignout();
                          }}
                        >
                          <span className="svg-icon svg-icon-2  ">
                            <img
                              src={Logout}
                              alt="icon"
                              width={22}
                              height={22}
                              className="svg-icon"
                            />
                          </span>
                          <span className="menu-link fs-14 px-2">Logout</span>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                      <span
                        className="box-purple text-white-btn fs-14 py-2 px-2 align-self-center cursor-pointer"
                        onClick={() => {
                          navigate("/signin-username");
                        }}
                      >
                        <img src={login} alt="icon" className="svg-icon" />{" "}
                        {t("SignUpPage.login")}
                      </span>
                    </div>
                    <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                      <span
                        className="box-purple text-white-btn  fs-14 py-2 px-2 align-self-center cursor-pointer"
                        onClick={() => {
                          navigate("/signup");
                        }}
                      >
                        <img src={Profile} alt="icon" className="svg-icon" />{" "}
                        {t("SignUpPage.signUp")}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </nav>
        <hr className="m-0" />
      </div>
    </>
  );
};

export default Navbar;
